import React, { useCallback, useState } from "react";

// Big touch button for the tractor beam. Sets inputRef.current.beam while
// pressed. Mirrors the keyboard/mouse beam behaviour exactly.
export default function BeamButton({ inputRef, timeLeft = 10, maxHold = 10, locked = false }) {
  const [pressed, setPressed] = useState(false);

  const down = useCallback(
    (e) => {
      e.preventDefault();
      try {
        e.currentTarget.setPointerCapture(e.pointerId);
      } catch (_) {}
      inputRef.current.beam = true;
      setPressed(true);
    },
    [inputRef]
  );
  const up = useCallback(
    (e) => {
      e.preventDefault();
      inputRef.current.beam = false;
      setPressed(false);
    },
    [inputRef]
  );

  const pct = Math.max(0, Math.min(100, (timeLeft / maxHold) * 100));

  return (
    <button
      type="button"
      className={`beam-button ${pressed ? "pressed" : ""} ${locked ? "locked" : ""}`}
      onPointerDown={down}
      onPointerUp={up}
      onPointerCancel={up}
      onPointerLeave={up}
      data-testid="beam-button"
      aria-label="Tractor beam"
    >
      <svg
        className="beam-button-ring"
        viewBox="0 0 100 100"
        aria-hidden="true"
      >
        <circle
          cx="50"
          cy="50"
          r="45"
          fill="none"
          stroke="rgba(255,255,255,0.08)"
          strokeWidth="6"
        />
        <circle
          cx="50"
          cy="50"
          r="45"
          fill="none"
          stroke={locked ? "#ff8b8b" : "#c2ff5d"}
          strokeWidth="6"
          strokeLinecap="round"
          strokeDasharray={`${(2 * Math.PI * 45 * pct) / 100} 999`}
          transform="rotate(-90 50 50)"
        />
      </svg>
      <span className="beam-button-label">
        <strong>BEAM</strong>
        <small>{locked ? "release" : `${timeLeft.toFixed(1)}s`}</small>
      </span>
    </button>
  );
}
